export type AuthTokenType = 'local' | 'manarah'

const TOKEN_TYPE_STORAGE_KEY = 'token_type'

export function getAuthTokenType(): AuthTokenType {
  return localStorage.getItem(TOKEN_TYPE_STORAGE_KEY) === 'manarah' ? 'manarah' : 'local'
}

export function isManarahAuth(): boolean {
  return getAuthTokenType() === 'manarah'
}

export function getAuthorizationHeader(token = localStorage.getItem('token')): string | null {
  if (!token) return null

  return isManarahAuth() ? `Bearer ${token}` : token
}

export function persistAuthToken(token: string, type: AuthTokenType): void {
  localStorage.setItem('token', token)
  localStorage.setItem(TOKEN_TYPE_STORAGE_KEY, type)
}

export function clearAuthToken(): void {
  localStorage.removeItem('token')
  localStorage.removeItem(TOKEN_TYPE_STORAGE_KEY)
  localStorage.removeItem('user')
  localStorage.removeItem('selected-session-id')
}
